import React from 'react';
import { Column } from '../../components/column';
import { Text } from '../../components/text';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { addBorderClasses } from './common';
import FooterLink from './footer-link';
const ContactsSection = ({ address, isVisible, phone, showBorderLeft, showBorderRight, width, textColor, fontFamily, paddingLeft, paddingRight, isRtl, }) => {
    return isVisible ? (React.createElement(Column, { cssClass: `html-emails-footer-section ${addBorderClasses({
            showBorderRight,
            showBorderLeft,
            isRtl,
        })} bigger-column-height ${mobileFullWidthColumnClassName}`, direction: isRtl ? 'rtl' : 'ltr', verticalAlign: "middle", width: width, paddingRight: paddingRight, paddingLeft: paddingLeft },
        React.createElement(Text, { align: "center", lineHeight: "17px", cssClass: "html-emails-footer-business-details-with-mobile-divider", padding: "0px 10px 0px 10px" },
            address.active && (React.createElement(FooterLink, { ...address, textColor: textColor, fontFamily: fontFamily })),
            address.active && phone.active && React.createElement("br", null),
            phone.active && (React.createElement(FooterLink, { ...phone, textColor: textColor, fontFamily: fontFamily }))))) : null;
};
export const FooterBusinessDetails = ContactsSection;
//# sourceMappingURL=footer-business-details.js.map